import * as Sentry from '@sentry/nextjs';
import { toast } from 'react-toastify';

export const handleErrors = async (error, context) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log('Error:', error);
    if (error.response) {
      console.log('Response data:', error.response.data);
      console.log('Response status:', error.response.status);
      console.log('Response headers:', error.response.headers);
    } else if (error.request) {
      console.log('Request:', error.request);
    } else {
      console.log('Error message:', error.message);
    }

    console.log('Request config:', error.config);
    return null;
  }

  let eventId = null;

  Sentry.withScope((scope) => {
    if (context) {
      Object.entries(context).forEach(([key, value]) => {
        scope.setContext(key, value);
      });
    }

    eventId = Sentry.captureException(error);
  });

  // Only flush on the server to ensure the event is sent before the response ends
  if (typeof window === 'undefined') {
    try {
      await Sentry.flush(2000);
    } catch (sentryError) {
      console.error('Sentry flush error:', sentryError);
    }
  }
  // Show notification on client
  else {
    toast.error('Nešto je pošlo po zlu.');
  }

  return eventId;
};
